/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { knowledgeHubCategoryRoute } from '@jira/router-routes__servicedesk-knowledge-hub-routes/src/knowledgeHubCategoryRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getKnowledgeHubResources } from './common/getKnowledgeHubResources.tsx';
import ServiceDeskKnowledgeHubCategory, {
	LazyServicedeskKnowledgeHubCategory,
} from './ui/category/index.tsx';

export const knowledgeHubCategoryRouteEntry: Route = createEntry(knowledgeHubCategoryRoute, () => ({
	group: 'servicedesk',
	ufoName: 'service-management.knowledge.category',
	// eslint-disable-next-line no-restricted-syntax
	component: ServiceDeskKnowledgeHubCategory,
	layout: serviceProjectLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [
		...getServiceDeskNavigationResources(),
		...getKnowledgeHubResources(),
		getConsolidationStateResource(),
	],

	forPaint: [LazyAtlassianNavigation, LazyServicedeskKnowledgeHubCategory],

	meta: {
		reporting: {
			id: APP_NAMES.KB_CATEGORY,
			packageName: toPackageName(APP_NAMES.KB_CATEGORY),
			teamName: 'jsm-nebula',
		},
	},

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
